export const getFetchWithTimeout = (fetchFn: typeof fetch, timeout: number): typeof fetch => {
    return async (input: RequestInfo | URL, init: RequestInit = {}): Promise<Response> => {
        init.signal = AbortSignal.timeout(timeout);
        return await fetchFn(input, init);
    };
};
